import 'remixicon/fonts/remixicon.css';
import { Route, Switch, useRouteMatch } from "react-router-dom";
import TeacherStudentsNav from './TeacherStudentsNav';
import { TeacherData } from '../../store/viewmodels/TeacherViewModel';
import { useAppSelector } from '../../store/Hooks';
import { Student } from '../../store/viewmodels/StudentViewModel';
import TeacherResults from './TeacherResults';
import TeacherStudents from './TeacherStudents';

function TeacherStudentsMain() {
    let { path } = useRouteMatch();

    const teacherData: TeacherData = useAppSelector(state => state.teacherData);
    const user = teacherData.isAuthenticated ? teacherData.teacher : null;

    let allStudents = user ? user.students : [];
    let unusedKeys: Student[] = [];
    let usedKeys: Student[] = [];

    for (let i: number = 0; i < allStudents.length; i++) {
        let results = allStudents[i].results;
        if (results !== undefined && results.length > 0) {
            usedKeys.push(allStudents[i]);
        }
        else {
            unusedKeys.push(allStudents[i]);
        }
    }

    return (
        <div className="flex-grow">
            <TeacherStudentsNav />
            <div className="">
                <Switch>
                    <Route path={`${path}/unusedKeys`}>
                        <h2 className="mt-4 mb-2 px-0 sm:px-6 lg:px-0 text-2xl font-bold text-gray-900">{"Käyttämättömät oppilastunnukset"}</h2>
                        <div className="mb-4 px-0 sm:px-6 lg:px-0">
                            <p>Voit tällä sivulla muokata luotuja oppilastunnuksia tai poistaa käyttämättömäksi jääneitä tunnuksia.</p>
                        </div>
                        <div className="border flex flex-grow w-full">
                            <TeacherStudents path={path} students={unusedKeys} used={false} />
                        </div>
                    </Route>
                    <Route path={`${path}/usedKeys`}>
                        <h2 className="mt-4 mb-4 px-4 sm:px-6 lg:px-8 text-2xl font-bold text-gray-900">{"Oppilaat"}</h2>
                        <div className="mb-4 px-0 sm:px-6 lg:px-0">
                            <p>Voit tällä sivulla muokata oppilaiden tietoja sekä tehtäviä. Oppilastunnusta, jolla on tallentuneena tehtävien tuloksia, ei voi poistaa.</p>
                        </div>
                        <div className="border flex flex-grow w-full">
                            <TeacherStudents path={path} students={usedKeys} used={true} />
                        </div>
                    </Route>
                    <Route path={`${path}/results`}>
                        <h2 className="mt-4 mb-4 px-4 sm:px-6 lg:px-8 text-2xl font-bold text-gray-900">{"Oppilaiden tulokset"}</h2>
                        <div className="mb-4 px-0 sm:px-6 lg:px-0">
                            <p>Voit tällä sivulla tarkastella oppilaiden tuloksia.</p>
                        </div>
                        <div className="border flex flex-grow w-full">
                            <TeacherResults students={usedKeys} />
                        </div>
                    </Route>
                    <Route path={`${path}/`}>
                        <div className="mb-4 px-0 sm:px-6 lg:px-0">
                            <p className="text-xl">Oppilasnäkymän etusivu</p>
                        </div>
                    </Route>
                </Switch >
            </div >
        </div >
    );
}

export default TeacherStudentsMain;